import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {map, Observable} from "rxjs";
import {User} from "./user";
import {ApiResponse, getDataOrFail} from "../common/api-utils";
import {LoginData} from '../login/login-data';
import {environment} from '../../environments/environment';
import {ResetPasswordData} from '../reset-password/reset-password-data';
import {UserStub} from "./user-stub";
import {QuickLinkAnswer} from "../home/quick-link-answer";
import {AdminUser} from "../user-admin/admin-user";

@Injectable({
    providedIn: 'root'
})
export class UserService {

    constructor(private http: HttpClient) {
    }

    search(searchTerm: string): Observable<UserStub[]> {
        return this.http.get<ApiResponse<UserStub[]>>(environment.apiUrl + `users.json`, {
            params: {
                q: searchTerm
            }
        }).pipe(map(getDataOrFail));
    }

    getLoggedInUser(): Observable<User> {
        return this.http.get<ApiResponse<User>>(environment.apiUrl + `user.json`).pipe(map(getDataOrFail));
    }

    login(data: LoginData): Observable<User> {
        return this.http.post<ApiResponse<User>>(environment.apiUrl + `user/login.json`, data).pipe(map(getDataOrFail));
    }

    logout(): Observable<any> {
        return this.http.post<any>(environment.apiUrl + `user/logout.json`, {}).pipe(map(getDataOrFail));
    }

    updateUser(user: User): Observable<any> {
        return this.http.put<ApiResponse<User>>(environment.apiUrl + `user.json`, user).pipe(map(getDataOrFail));
    }
    switchUser(user: AdminUser): Observable<any> {
        return this.http.get<ApiResponse<User>>(environment.apiUrl + `user.json?_switch_user=` + user.username).pipe(map(getDataOrFail));
    }
    switchUserPost(user: AdminUser): Observable<any> {
        const data = {
            username: user.username,
        }
        return this.http.post<{success: boolean}>(environment.apiUrl + `user/switch.json`, data)
    }
    switchUserBackPost(): Observable<any> {
        const data = {
            username: '_exit',
        }
        return this.http.post<{success: boolean}>(environment.apiUrl + `user/switch.json`, data)
    }
    switchUserBack(): Observable<any> {
        return this.http.get<ApiResponse<User>>(environment.apiUrl + `user.json?_switch_user=_exit`).pipe(map(getDataOrFail));
    }
    resetPassword(email: string, code?: string, pw?: string): Observable<any> {
        const data: ResetPasswordData = {
            email: email
        }
        if (code) {
            data.passwordResetCode = code;
        }
        if (pw) {
            data.password = pw
        }
        return this.http.post(environment.apiUrl + 'resetPassword.json', data);

    }
    getAnonUserContent() {
        return this.http.get('json/static_content.json');
    }
    getQuickLinks() {
        return this.http.get<QuickLinkAnswer>(environment.apiUrl + `quickLinks/home.json`);
    }
    getUserCountries(locale: string) {
        return this.http.get<any>(environment.apiUrl + 'countries/' + locale + '.json')
    }

}
